if(!customElements.get('pickup-availability')){
    class PickupAvailability extends HTMLElement {
        static observedAttributes = ['data-variant-id'];

        constructor(){
            super();

            this.rootUrl = this.dataset.rootUrl;

            if(!this.rootUrl.endsWith('/')){
                this.rootUrl = this.rootUrl + "/";
            }

            this.buttonType = this.dataset.buttonType;
            this.abortController = null;
        }

        connectedCallback(){
            this.fetchAvailability(this.dataset.variantId);
        }

        attributeChangedCallback(name, oldValue, newValue){
            if(name === 'data-variant-id' && oldValue !== null && oldValue !== newValue){
                this.fetchAvailability(newValue);
            }
        }

        fetchAvailability(variantId){
            if(!variantId) return;

            if(this.abortController){
                this.abortController.abort();
            }
            this.abortController = new AbortController();

            const variantSectionURL = `${this.rootUrl}variants/${variantId}/?section_id=pickup-availability`;

            fetch(variantSectionURL, { signal: this.abortController.signal })
            .then(res => res.text())
            .then(text => {
                if(!this.isConnected) return;

                const sectionInnerHTML = new DOMParser()
                .parseFromString(text, 'text/html')
                .querySelector('.shopify-section');

                this.renderPreview(sectionInnerHTML);
            }).catch(e => {
                if(e.name === 'AbortError') return;
                this.renderError();
            })
        }

        renderPreview(sectionInnerHTML){
            const drawer = document.querySelector('pickup-availability-drawer');
            if(drawer) drawer.remove();

            if(!sectionInnerHTML.querySelector('pickup-availability-preview')){
                this.innerHTML = '';
                this.setAttribute('aria-hidden', 'true');
                return;
            }

            if(this.buttonType !== ''){
                const button = sectionInnerHTML.querySelector('.button-pickup-availability');
                if(button) button.classList.add(`button--${this.buttonType}`);
            }

            this.innerHTML = sectionInnerHTML.querySelector('pickup-availability-preview').outerHTML;
            this.setAttribute('aria-hidden', 'false');

            document.body.appendChild(sectionInnerHTML.querySelector('pickup-availability-drawer'));

            this.buttonPickupAvailability = this.querySelector('.button-pickup-availability');
            if(this.buttonPickupAvailability){
                this.buttonPickupAvailability.addEventListener("click", (e) => {
                    e.preventDefault();
                    const pickupAvailabilityDrawer = document.querySelector('pickup-availability-drawer');
                    if(pickupAvailabilityDrawer) pickupAvailabilityDrawer.openDrawer();
                });
            }
        }

        renderError(){
            this.innerHTML = '';
        }
    }
    customElements.define('pickup-availability', PickupAvailability);
}

if(!customElements.get('pickup-availability-drawer')){
    class PickupAvailabilityDrawer extends HTMLElement {
        constructor(){
            super();
        }

        connectedCallback(){
            // close drawer
            this.addEventListener('click', this.onDrawerClick.bind(this));
            this.querySelectorAll('[data-close]').forEach(item => {
                item.addEventListener('click', this.closeDrawer.bind(this));
                item.addEventListener('keydown', e => {
                    if(e.key === 'Enter' || e.key === ' '){
                        e.preventDefault();
                        this.closeDrawer();
                    }
                });
            });
            this.addEventListener('keyup', e => {
                if(e.code && e.code.toUpperCase() === 'ESCAPE'){
                    this.closeDrawer();
                }
            });
        }

        openDrawer(){
            this.setAttribute('data-hidden', 'false');
            this.removeAttribute('inert');

            document.body.style.overflow = 'hidden';
            document.documentElement.style.overflow = 'hidden';

            this.previouslyFocusedElement = document.activeElement;

            FocusTrap.activate(this);
            this.addFocus();
        }

        onDrawerClick(e){
            const isDrawerClicked = e.target === e.currentTarget;
            if(isDrawerClicked){
                this.closeDrawer();
            }
        }

        closeDrawer(){
            FocusTrap.deactivate(this);

            this.setAttribute('data-hidden', 'true');
            this.setAttribute('inert', '');

            document.body.style.overflow = '';
            document.documentElement.style.overflow = '';

            if(this.previouslyFocusedElement){
                this.previouslyFocusedElement.focus();
            }
        }

        addFocus(){
            setTimeout(() => {
                const buttons = this.querySelectorAll('button');
                if(buttons.length > 0){
                    buttons[0].focus();
                }
            }, 100);
        }
    }
    customElements.define('pickup-availability-drawer', PickupAvailabilityDrawer);
}
